import React, {
  forwardRef,
  useCallback,
  useEffect,
  useImperativeHandle,
  useState,
} from "react";
import { Box } from "@material-ui/core";
import { GetAllScopeDocuments } from "../../../../../../Services";
import { ScopeDocumentEnum } from "../../../../../../Enums";
import { DocumentsPropertyCard } from "../../../../../../Components/V2/DocumentsPropertyCard";
import DocumentsPropertyCardSkeleton from "../../../../../../Components/V2/SkeletonLoader/DocumentsPropertyCardSkeleton/DocumentsPropertyCardSkeleton";
import { CustomPagination, NoDataFound } from "../../../../../../Components";

//  styles
import useStyles from "./styles";

const DocumentTab = forwardRef(({ propertyId }, ref) => {
  const styles = useStyles();
  const [isLoading, setIsLoading] = useState(false);
  const [documents, setDocuments] = useState({
    result: [],
    totalCount: 0,
  });
  const [pagination, setPagination] = useState({
    pageSize: 25,
    pageIndex: 1,
  });
  const [inputValue, setInputValue] = useState(pagination.pageIndex);

  const uploadDocHandler = () => {};

  const getDocumentByFormId = useCallback(async () => {
    setIsLoading(true);
    const body = {
      scopeId: propertyId,
      pageSize: pagination.pageSize,
      pageIndex: pagination.pageIndex - 1,
      scopeTypeId: ScopeDocumentEnum.Property.scopeTypeId,
    };
    const result = await GetAllScopeDocuments(body);
    if (!(result && result.status && result.status !== 200)) {
      setDocuments({
        result: (result && result.result) || [],
        totalCount: (result && result.totalCount) || 0,
      });
    } else {
      setDocuments({
        result: [],
        totalCount: 0,
      });
    }
    setIsLoading(false);
  }, [propertyId, pagination]);

  useEffect(() => {
    getDocumentByFormId();
  }, [pagination, propertyId]);

  useImperativeHandle(ref, () => ({
    uploadDocHandler,
  }));

  return (
    <>
      <Box className={styles.wrapperDocTab}>
        {isLoading ? (
          Array.from({ length: 8 }).map((_, idx) => (
            <DocumentsPropertyCardSkeleton key={idx} />
          ))
        ) : documents?.result?.length === 0 ? (
          <NoDataFound title="documents Property" />
        ) : (
          documents?.result &&
          documents?.result?.map((doc, idx) => (
            <DocumentsPropertyCard
              key={idx}
              documentItem={doc}
              refetchData={() => {
                getDocumentByFormId();
              }}
            />
          ))
        )}
      </Box>
      <CustomPagination
        totalItems={documents.totalCount}
        itemsPerPage={pagination.pageSize}
        currentPage={pagination.pageIndex}
        inputValue={inputValue}
        setInputValue={setInputValue}
        onPageChange={(page) =>
          setPagination((prev) => ({ ...prev, pageIndex: page }))
        }
        onItemsPerPageChange={(items) =>
          setPagination((prev) => ({ ...prev, pageSize: items }))
        }
        isLoading={isLoading}
      />
    </>
  );
});

export default DocumentTab;
